import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Wallet from '../Wallet';
import styles from './Header.module.css';
const Header = () => {
	const navigate = useNavigate();
	const login = () => {
		navigate('/demo');
	};
	return (
		<nav className={styles.container}>
			<Link className={styles.heading} to="/">
				<h1>Ovet</h1>
			</Link>

			<div className={styles.navlinks}>
				<Link to="/about">About</Link>
				<Link to="/dashboard">Dashboard</Link>
				{/* <button
					onClick={() => {
						login();
					}}
					className={styles.loginBtn}
				>
					Login
				</button> */}
				<Wallet />
			</div>
		</nav>
	);
};

export default Header;
